import { LEAF_INDEX } from '@tandemone/types'

import type {
  CapabilitiesDerived,
  CapabilitiesFormState,
  CapabilityLeafRow
} from './capabilities-context'

/** a selected leaf still needs years >= 1 and exactly one sourcing flag. */
export function isIncomplete(row: CapabilityLeafRow): boolean {
  return row.yearsInBusiness === 0 || (!row.inHouse && !row.subContracted)
}

export function deriveCapabilities(
  state: CapabilitiesFormState
): CapabilitiesDerived {
  const countsByGroup: Record<string, number> = {}
  const countsByCategory: Record<string, number> = {}
  let incompleteCount = 0
  for (const [key, row] of Object.entries(state.rows)) {
    const info = LEAF_INDEX[key]
    if (info) {
      countsByGroup[info.groupKey] = (countsByGroup[info.groupKey] ?? 0) + 1
      countsByCategory[info.categoryKey] =
        (countsByCategory[info.categoryKey] ?? 0) + 1
    }
    if (isIncomplete(row)) incompleteCount += 1
  }
  const selectedCount = Object.keys(state.rows).length
  const isValid =
    state.noneSelected || (selectedCount >= 1 && incompleteCount === 0)
  return {
    selectedCount,
    incompleteCount,
    isValid,
    countsByGroup,
    countsByCategory
  }
}

/** case-insensitive substring match against any of the passed labels; an empty
 *  query matches everything (the picker shows the full tree). */
export function labelMatches(query: string, ...labels: string[]): boolean {
  if (!query) return true
  const q = query.toLowerCase()
  return labels.some(label => label.toLowerCase().includes(q))
}
